import { cn } from "@/utils/cn";
import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";

interface SelectProps {
  label?: string;
  helper?: string;
  options: { value: string; label: string }[];
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  leftIcon?: ReactNode;
}

export function Select({
  label,
  helper,
  options,
  value,
  onChange,
  placeholder,
  className,
  leftIcon,
}: SelectProps) {
  return (
    <div className={cn("w-full", className)}>
      {label && (
        <label className="block text-sm font-medium text-[#374151] mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]">
            {leftIcon}
          </div>
        )}
        <select
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className={cn(
            "w-full appearance-none rounded-lg border border-[#E2E8F0] bg-white px-3 py-2 text-sm text-[#1A1F2C] focus:border-[#ff0000] focus:outline-none focus:ring-2 focus:ring-[#ff0000]/10 transition-all",
            leftIcon && "pl-10"
          )}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#94A3B8] pointer-events-none" />
      </div>
      {helper && (
        <p className="mt-1.5 text-xs text-[#5A6A85]">
          {helper}
        </p>
      )}
    </div>
  );
}
